import { CloudXIntegrationDataSchema } from "@redotech/redo-return-core-common/integrations/returns/cloudx/types";
import { null as zNull } from "zod";

export const postCloudXIntegration = {
  name: "postCloudXIntegration" as const,
  input: CloudXIntegrationDataSchema,
  output: zNull(),
};
